import { Component, inject, OnInit } from '@angular/core';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { AuthService } from '../providers/auth.service';
import { SidebarService } from '../providers/sidebar.service';
import { CommonModule } from '@angular/common';
import { DbService } from '../providers/db.service';
import { FormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { RouterLink } from '@angular/router';
import { CategoryInterface, PeriodsInterface } from '../interfaces';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [TranslocoDirective, CommonModule, FormsModule, RouterLink],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css'
})
export class DashboardComponent implements OnInit {
  showSpinner = true;
  catsArray: CategoryInterface[] = [];
  periodsArray: PeriodsInterface[] = [];
  periodsShortArray: number[] = [];
  sideBarSize = '';
  selectedCategory = -1;
  maxNumberOfCategories = 8;
  period = 0;
  prevPeriod = 0;
  minPeriod = 0;
  currentPeriod = 0;
  periodTranslocoTemp = '';
  periodTransloco = '';
  totalBudget = 0;
  totalExpense = 0;
  countExpense = 0;
  totalBudgetPrev = 0;
  totalExpensePrev = 0;
  countExpensePrev = 0;
  periodModel = '0';
  categoriesView = 'grid';

  public db = inject(DbService);
  public auth = inject(AuthService);
  private translocoService = inject(TranslocoService);
  private toastr = inject(ToastrService);
  public sb = inject(SidebarService);
  budgetModel = {
    name: 'test',
    value: 0
  };

  ngOnInit(): void {
    this.ngOnInitAsync()
  }

  async ngOnInitAsync() {
    try {
      const now = new Date();
      this.period = parseInt(now.toISOString().substring(0, 10).substring(0, 7).replace("-", ""));
      this.currentPeriod = this.period;
      now.setMonth(now.getMonth() - 1);
      this.prevPeriod = parseInt(now.toISOString().substring(0, 10).substring(0, 7).replace("-", ""));
      this.periodTranslocoTemp = 'calendar.'.concat(this.period.toString());
      await this.listOfCatsAndBudgets();
      this.showSpinner = false;
      await this.listOfPeriods();
      this.periodTransloco = this.translocoService.translate(this.periodTranslocoTemp, undefined, this.auth.currentUserSig()?.lang);
      this.sideBarSize = this.sb.currentSidebarSize();
    } catch (err) {
      console.log(err.code)
    }
  }

  async listOfCatsAndBudgets(): Promise<void> {
    try {
      this.catsArray = await this.db.getCatsAsync(this.auth.currentUserIDSig().uid);
      this.totalBudget = 0;
    } catch (err) {
      console.error('Error while fetching categories:', err);
    }
  }

  async listOfPeriods(): Promise<void> {
    try {
      this.periodsShortArray = []
      this.periodsArray = await this.db.getPeriodsAsync(this.auth.currentUserIDSig().uid);
      for (const period of this.periodsArray) {
        this.periodsShortArray.push(period.content['periodID']);
        if (period.content['periodID'] === this.period) {
          this.totalBudget = period.content['budget']
          this.totalExpense = period.content['expense']
          this.countExpense = period.content['transactions']
        }
        if (period.content['periodID'] === this.prevPeriod) {
          this.totalBudgetPrev = period.content['budget']
          this.totalExpensePrev = period.content['expense']
          this.countExpensePrev = period.content['transactions']
        }
      }
      this.periodsShortArray.sort()
      this.minPeriod = this.periodsShortArray[0]
      this.periodsShortArray.reverse()
    } catch (err) {
      console.log('Error fetching periods:', err)
    }
  }

  // async updateMonthlyBudget(model: { value: number; }, docID: string, period: number): Promise<void> {
  //   const newBudget = model.value;
  //   let periodDocID = 'xxx';
  //   try {
  //     for (const per of this.periodsArray) {
  //       if (per.content['periodID'] === period) {
  //         periodDocID = per.id
  //       }
  //     }
  //     await this.db.updateBudgetInCategoriesAsync(period, model.value, docID,this.auth.currentUserIDSig().uid);
  //     const deltaBudget = newBudget - this.catsArray[this.selectedCategory].content[period].budget;
  //     await this.db.updateBudgetInPeriodsAsync(period, deltaBudget,this.auth.currentUserIDSig().uid);
  //     await this.listOfCatsAndBudgets();
  //     await this.listOfPeriods();
  //     this.showToast('success', `${this.translocoService.translate('toasts.budgetSuccessMessage', undefined, this.auth.currentUserSig()?.lang)}`)
  //   } catch (err) {
  //     console.log(err.code)
  //     this.showToast('error', `${this.translocoService.translate('toasts.budgetFailMessage', undefined, this.auth.currentUserSig()?.lang)}`)
  //   }
  // }

  toggleCategoriesView(currentView: string) {
    if (currentView == 'grid') {
      this.categoriesView = 'table'
    } else {
      this.categoriesView = 'grid'
    }
  }

  calculateAbs(currentNumber: number, previousNumber: number) {
    return Math.abs(currentNumber - previousNumber)
  }

  currencyFormatter(currency: string) {
    if (currency === 'PLN') {
      return 'zł'
    } else if (currency === 'USD') {
      return '$'
    } else if (currency === 'EUR') {
      return '€'
    } else {
      return null
    }
  }

  setPeriod(newPeriod: number) {
    this.period = newPeriod;
    if (newPeriod.toString().substring(4, 6) === '01') {
      this.prevPeriod = parseInt((parseInt(newPeriod.toString().substring(0, 4)) - 1).toString().concat('12'))
    } else {
      this.prevPeriod = newPeriod - 1
    }
    for (const period of this.periodsArray) {
      if (period.content['periodID'] === newPeriod) {
        this.totalBudget = period.content['budget']
        this.totalExpense = period.content['expense']
        this.countExpense = period.content['transactions']
      }
      if (period.content['periodID'] === this.prevPeriod) {
        this.totalBudgetPrev = period.content['budget']
        this.totalExpensePrev = period.content['expense']
        this.countExpensePrev = period.content['transactions']
      }
    }
  }

  daysLeftInMonth() {
    const date = new Date();
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate() - date.getDate();
  }

  showToast(toastType: string, title: string, content?: string) {
    const varTimeOut = 4000;
    const varProgressBar = true;
    const varPositionClass = 'toast-top-center';
    if (toastType === 'success') {
      this.toastr.success(content, title, {
        timeOut: varTimeOut,
        progressBar: varProgressBar,
        positionClass: varPositionClass
      });
    } else if (toastType === 'info') {
      this.toastr.info(content, title, {
        timeOut: varTimeOut,
        progressBar: varProgressBar,
        positionClass: varPositionClass
      });
    } else {
      this.toastr.error(content, title, {
        timeOut: varTimeOut,
        progressBar: varProgressBar,
        positionClass: varPositionClass
      });
    }
  }
}

